import React from 'react';
import '../../App.css';

export default function Products() {
  return <h1 className='products'>This function will be available once the products are presented and launched in the market. <br />Please check back later</h1>;
}
